'use client';

import React, { useState, useEffect } from 'react';
import Icon from '@/components/ui/AppIcon';

export default function StickyContactBar() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 600);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <div className={`fixed bottom-0 left-0 right-0 z-40 transition-transform duration-300 ${visible ? 'translate-y-0' : 'translate-y-full'}`}>
      <div className="bg-card border-t border-border shadow-elevated">
        <div className="max-w-screen-2xl mx-auto px-6 lg:px-10 py-4 flex items-center justify-between gap-6">
          <div className="flex items-center gap-4 min-w-0">
            <div className="w-10 h-10 rounded-xl bg-primary/20 flex items-center justify-center flex-shrink-0">
              <Icon name="HomeIcon" size={20} className="text-primary" />
            </div>
            <div className="min-w-0">
              <div className="font-bold text-foreground text-sm truncate">Saadiyat Beach Villa</div>
              <div className="text-2xl font-extrabold text-primary font-tabular">AED 18.5M</div>
            </div>
          </div>

          <div className="flex items-center gap-3 flex-shrink-0">
            <a href="tel:+97150234 5678" className="flex items-center gap-2 px-5 py-2.5 bg-primary text-white rounded-xl font-semibold text-sm hover:bg-primary-dark transition-all active:scale-95">
              <Icon name="PhoneIcon" size={16} />
              <span className="hidden md:inline">Call Agent</span>
            </a>
            <a href="https://wa.me/971502345678" className="flex items-center gap-2 px-5 py-2.5 bg-green-600 text-white rounded-xl font-semibold text-sm hover:bg-green-700 transition-all active:scale-95">
              <Icon name="ChatBubbleLeftEllipsisIcon" size={16} />
              <span className="hidden md:inline">WhatsApp</span>
            </a>
            <button className="flex items-center gap-2 px-5 py-2.5 border-2 border-primary text-primary rounded-xl font-semibold text-sm hover:bg-primary hover:text-white transition-all active:scale-95">
              <Icon name="CalendarDaysIcon" size={16} />
              <span className="hidden md:inline">Book Viewing</span>
            </button>
            <button className="flex items-center gap-2 px-5 py-2.5 bg-accent text-accent-foreground rounded-xl font-semibold text-sm hover:bg-accent-dark transition-all active:scale-95">
              <Icon name="EnvelopeIcon" size={16} />
              <span className="hidden md:inline">Send Inquiry</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}